// extracted by mini-css-extract-plugin
export default {"userPanel":"UserPanel_userPanel__O2r+8","helloTitle":"UserPanel_helloTitle__FcQX1","userNameHello":"UserPanel_userNameHello__-2m9p"};